export default {
	name: "ButtonBlock",
	data() {
		return {}
	},
	props: {
		title: String
	},
	created() {},
	watch: {},
	computed: {},
	methods: {}
}



// WEBPACK FOOTER //
// ./src/components/blocks/button/button.block.js